import { DatePicker, Input, Table, Modal, Button } from "antd";
import React, { Component } from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { httpGet, httpPost, httpUrl, serverUrl } from "../../api/httpClient";
import CoinSelectBox from "../../components/common/CoinSelectBox";
import SelectBox from "../../components/common/SelectBox";
import string from "../../string";
import { amountFormat, formatDate } from "../../util";
import { numberFormat } from "../../util";
import moment from "moment";

const Search = Input.Search;
const { RangePicker } = DatePicker;

const statusString = [
  '신청중',
  '승인',
  '거절'
];

class SwapBettingStat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tables: [],
      userListVisible: false,
      selectedUser: {idx: 0, name: '전체', id: ''},
      pagination: {
        total: 0,
        current: 1
      },
    };
  }

  componentDidMount() {
    this.getList();
  }
  handleTableChange = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    }, ()=>this.getList());
  };

  getList = () => {
    let pageNum = this.state.pagination.current;
    httpGet(httpUrl.swaptalkStatList,[10,pageNum,this.state.selectedUser.idx],{}).then((res) => {
      const pagination = { ...this.state.pagination };
      pagination.current = res.data.currentPage;
      pagination.total = res.data.totalCount;
      this.setState({
        tables: res.data.list,
        pagination,
      });
    });
  };
  render() {
    const { tables } = this.state;
    const columns = [
        {
          title: "날짜",
          dataIndex: "logDate",
          className: "support-column-number fs-15 lh-21",
          render: value => moment(value, 'YYYYMMDD').format('YYYY-MM-DD')
        },
        {
          title: "게임횟수",
          dataIndex: "count",
          className: "support-column-number fs-15 lh-21",
        },
        {
          title: "USDT총액",
          dataIndex: "usdtValueTotal",
          className: "support-column-number fs-15 lh-21",
          render: value => numberFormat(Math.floor(value/1000000))
        },
        {
          title: "USDT평균",
          dataIndex: "usdtValueAverage",
          className: "support-column-number fs-15 lh-21",
          render: value => numberFormat(Math.floor(value/1000000))
        },
        {
          title: "UP선택",
          dataIndex: "upCount",
          className: "support-column-number fs-15 lh-21",
        },
        {
          title: "DOWN선택",
          dataIndex: "downCount",
          className: "support-column-number fs-15 lh-21",
        },
        {
          title: "UP비율",
          dataIndex: "upCount",
          className: "support-column-number fs-15 lh-21",
          render: (value, row) => (row.upCount+row.downCount == 0 ? 0 : Math.floor(row.upCount / (row.upCount+row.downCount)*10000) / 100) + ' %'
        },
        {
          title: "평균수수료",
          dataIndex: "feeRatioAverage",
          className: "support-column-number fs-15 lh-21",
          render: (value, row) => (Math.floor(value*100) / 100) + ' %'
        },
        {
          title: "수수료총액(USDT)",
          dataIndex: "feeTotal",
          className: "support-column-number fs-15 lh-21",
          render: value => numberFormat(Math.floor(value/1000000))
        },

    ];

    return (
      <div>
        <div
          style={{
            fontSize: "20px",
            color: "#000",
            textAlign: "center",
            marginBottom: "30px",
            fontWeight: "bold",
          }}>
          일자별 통계
      </div>
        <div className="wrapper mt-35 width-1240" />
          <div className="flex-row flex-center" style={{paddingBottom: '10px'}}>
                <Button
                style={{ marginLeft: "10px" }}
                onClick={() => {
                    this.setState({userListVisible: true});
                }}>
                회원검색
                </Button>
                <Button
                style={{ marginLeft: "10px" }}
                onClick={() => {
                    this.setState({
                        selectedUser: {idx: 0, name: '전체', id: ''},
                        pagination: { total: 0, current: 1 },
                    }, this.getList);
                }}>
                전체보기
                </Button>
                <div style={{paddingLeft: '20px'}}>
                    현재검색조건: {this.state.selectedUser.name + (this.state.selectedUser.id && ('('+this.state.selectedUser.id+')'))}
                </div>
          </div>
        <Table
          rowKey={(record) => record.idx}
          rowClassName={(record) => (record.deleted ? "gray" : "")}
          dataSource={tables}
          columns={columns}
          pagination={this.state.pagination}
          onChange={this.handleTableChange}
        />
      </div>
    );
  }
}

export default SwapBettingStat;
